// extracted by mini-css-extract-plugin
export default {"body":"TableBody_body__8pZrz","empty":"TableBody_empty__dQ+i-"};